import { render, staticRenderFns } from "./SalesTrendCard.vue?vue&type=template&id=65a1ab2b&"
import script from "./SalesTrendCard.vue?vue&type=script&lang=js&"
export * from "./SalesTrendCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports